import { createContext, useEffect, useMemo, useState } from "react";
import { useAsync2 } from "nate-react-api-helpers";
import { api } from "../../../../api/API";
import { useSnackbar } from "../../../../misc/Snackbar";
import { useSyncedRef } from "../../../../misc/SyncedRef";
import { ProductEdit } from "../extras/ProductEdit";
import { useReloader } from "./ReloadContext";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const EditProductContext = /*#__PURE__*/ createContext({ show: (id, dimensionScreen) => { } });
export function EditProduct(props) { const [edit, setEdit] = useState(); const ctx = useMemo(() => { return { show: (id, dimensionScreen) => setEdit({ id: id, dimensionScreen: !!dimensionScreen }) }; }, []); const reloaderRef = useReloader(); return /*#__PURE__*/ _jsxs(EditProductContext.Provider, { value: ctx, children: [props.children, edit && /*#__PURE__*/ _jsx(EditProductDialog, { id: edit.id, mode: props.mode, dimensionScreen: edit.dimensionScreen, onClose: value => { setEdit(undefined); if (value) {
                reloaderRef.current();
            } } })] }); }
export function EditProductDialog(props) { const result = useAsync2(input => api.products.getById(input.id), { id: props.id }, [props.id]); const snackRef = useSyncedRef(useSnackbar()); useEffect(() => { if (result.loading) {
    snackRef.current.loading();
    return;
} if (result.error) {
    snackRef.current.error(result.error);
    return;
} snackRef.current.hide(); }, [snackRef, result.loading, result.error]); if (!result.result)
    return null; const val = result.result; return /*#__PURE__*/ _jsx(ProductEdit, { mode: props.mode, value: val, onClose: props.onClose }); }
